import React from "react";
import { resolveWidgetIcon } from "./widgetIcons";
import { resolveWidgetColor } from "./widgetColors";

const GRID_CLASSES = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
};

const FeatureGridWidget = ({ widget }) => {
  const props = widget.props || {};
  const items = Array.isArray(props.items) ? props.items : [];
  const gridClass = GRID_CLASSES[props.columns] || GRID_CLASSES[3];

  return (
    <div>
      {widget.title && <h3 className="font-semibold text-lg mb-4">{widget.title}</h3>}
      <div className={`grid grid-cols-1 gap-4 ${gridClass}`}>
        {items.map((item, i) => {
          const Icon = resolveWidgetIcon(item.icon);
          const palette = resolveWidgetColor(item.color);
          return (
            <div key={i} className="rounded-lg border border-gray-200 bg-white p-5">
              <div className={`inline-flex h-10 w-10 items-center justify-center rounded-lg ${palette.bg} ${palette.text} mb-3`}>
                <Icon size={20} />
              </div>
              {item.title && <h4 className="font-semibold text-gray-900">{item.title}</h4>}
              {item.description && <p className="mt-1 text-sm text-gray-600">{item.description}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureGridWidget;
